






























































































import { Component, Vue, Prop } from 'vue-property-decorator'
import { GalleryImageModule } from '@/app/store/modules/galleryImage'
import vueCustomScrollbar from 'vue-custom-scrollbar'
import { defaultImage } from '@/utils/default'

@Component({
  components: {
    vueCustomScrollbar,
  },
})
export default class extends Vue {
  @Prop({}) private idModal
  @Prop({}) private changeImageId
  @Prop({}) private imageData
  @Prop({}) private imageType
  @Prop({}) private cancelImageThumbnailId
  @Prop({}) private cancelImageLogoId
  @Prop({}) private cancelImageCoverId

  public settings = {
    maxScrollbarLength: 60,
  }

  public imageCoverId: boolean = false

  public currentImage: string = defaultImage
  public notSelect: boolean = true

  public get isLoading(): boolean {
    return GalleryImageModule.isLoading
  }
  // Upload File
  public hasFiles = {
    fileName: '',
    fileByte: '',
    fileUpload: null,
  }
  public changeFile(event) {
    const file = event.target.files[0]
    const input = event.target
    if (input.files && input.files[0]) {
      const reader = new FileReader()
      reader.onload = (e: any) => {
        const hash = e.target.result.split(',')
        this.hasFiles = {
          fileName: input.files[0].name,
          fileByte: hash.length ? hash[1] : '',
          fileUpload: input.files[0],
        }
        this.currentImage = URL.createObjectURL(file)
        this.notSelect = false
      }
      reader.readAsDataURL(input.files[0])
    }
  }
  public upload() {
    const image = {
      name: this.hasFiles.fileName,
      category: this.imageType.toLowerCase(),
      fileByte: this.hasFiles.fileByte,
      fileUpload: this.hasFiles.fileUpload,
    }
    GalleryImageModule.postGalleryImage(image)
    this.clearImage()
  }

  public $refs!: {
    reset: HTMLFormElement
  }

  public get selectItem(): boolean {
    if (this.imageCoverId === false) {
      return true
    } else {
      return false
    }
  }

  public clearImage() {
    this.$refs['file-input'].reset()
    this.currentImage = defaultImage
    this.notSelect = true
  }
  public imageSelected = null
  public get imageSelect(): any {
    let data: any
    if (this.imageType === 'Thumbnail') {
      data = this.imageData.filter((e) => e.category === 'thumbnail')
      this.imageSelected = null
    } else if (this.imageType === 'Cover') {
      data = this.imageData.filter((e) => e.category === 'cover')
      this.imageSelected = null
    } else if (this.imageType === 'Logo') {
      data = this.imageData.filter((e) => e.category === 'logo')
      this.imageSelected = null
    } else if (this.imageType === 'Icon') {
      data = this.imageData.filter((e) => e.category === 'icon')
      this.imageSelected = null
    }
    return data
  }
  // reset modal galeri
  public resetModalGaleri(bvtEvent) {
    this.imageSelected = null
    this.imageCoverId = false
    this.currentImage = defaultImage
    this.notSelect = true
    this.$refs['file-input'].reset()
    if (bvtEvent.trigger === 'headerclose') {
      this.cancelImageThumbnailId()
    }
  }
  public selectImages(button) {
    this.$root.$emit('bv::hide::modal', this.idModal, button)
  }
}
